/* Dawn Theme Custom Wishlist Engine */
const WISHLIST_KEY = 'ethnic_couture_wishlist';

const getWishlist = () => {
  try {
    return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
  } catch (e) {
    return [];
  }
};

const updateWishlistBadges = () => {
  const list = getWishlist();

  // Update header/nav badge counts
  document.querySelectorAll('[data-wishlist-count]').forEach((badge) => {
    badge.textContent = list.length;
    badge.style.display = list.length > 0 ? 'inline-flex' : 'none';
  });

  // Sync heart button states on product cards
  document.querySelectorAll('[data-wishlist-button]').forEach((btn) => {
    const handle = btn.getAttribute('data-product-handle') || btn.dataset.productHandle;
    const isAdded = list.includes(handle);
    btn.classList.toggle('is-active', isAdded);
    btn.setAttribute('aria-pressed', isAdded ? 'true' : 'false');
  });
};

const setWishlist = (handles) => {
  localStorage.setItem(WISHLIST_KEY, JSON.stringify(handles));
  updateWishlistBadges();
  window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { handles } }));
};

const toggleWishlistItem = (handle) => {
  let list = getWishlist();
  if (list.includes(handle)) {
    list = list.filter((item) => item !== handle);
  } else {
    list.push(handle);
  }
  setWishlist(list);
  return list.includes(handle);
};

// Global click handler using CAPTURE phase (true)
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist-button]');
  if (!btn) return;

  // Intercept the click before card <a> elements trigger navigation
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const handle = btn.getAttribute('data-product-handle') || btn.dataset.productHandle;
  if (!handle) {
    console.error('Wishlist Error: No product handle found on button', btn);
    return;
  }

  toggleWishlistItem(handle);

  // Direct DOM removal if clicked inside the wishlist page grid
  const gridItem = btn.closest('[data-wishlist-item]');
  if (gridItem && document.querySelector('.wishlist-page-grid')) {
    gridItem.remove();
    const remaining = getWishlist();
    if (remaining.length === 0) {
      const emptyContainer = document.getElementById('wishlist-empty') || document.querySelector('.wishlist-empty-state');
      if (emptyContainer) {
        emptyContainer.style.display = 'block';
        emptyContainer.classList.remove('hidden');
      }
      const grid = document.getElementById('wishlist-grid') || document.querySelector('.wishlist-page-grid');
      if (grid) {
        grid.style.display = 'none';
      }
    }
  }
}, true); // true = Capture phase intercepts ahead of theme links

// Sync badge on initial load
document.addEventListener('DOMContentLoaded', updateWishlistBadges);

// Listen to storage events across tabs
window.addEventListener('storage', (e) => {
  if (e.key === WISHLIST_KEY) {
    updateWishlistBadges();
  }
});

// Re-sync badges whenever Dawn loads products dynamically (pagination/filtering)
const productGrid = document.querySelector('#product-grid, .collection');
if (productGrid) {
  const observer = new MutationObserver(() => updateWishlistBadges());
  observer.observe(productGrid, { childList: true, subtree: true });
}

// Expose on window for template compatibility
window.EthnicWishlist = {
  get: getWishlist,
  set: setWishlist,
  toggle: toggleWishlistItem,
  updateUI: updateWishlistBadges
};


// Global click handler using CAPTURE phase (true) to run before the <a> tag
document.addEventListener('click', function (e) {
  const btn = e.target.closest('[data-wishlist-button]');
  
  // If the click is NOT on the wishlist button, allow normal link redirect
  if (!btn) return;

  // Kill the click completely so the parent <a> tag NEVER redirects
  e.preventDefault();
  e.stopPropagation();
  e.stopImmediatePropagation();

  const handle = btn.getAttribute('data-product-handle') || btn.dataset.productHandle;
  if (!handle) {
    console.error('Wishlist Error: No product handle found on button', btn);
    return;
  }

  const isNowActive = toggleWishlistItem(handle);

  // Update button state immediately
  btn.classList.toggle('is-active', isNowActive);
  btn.setAttribute('aria-pressed', isNowActive ? 'true' : 'false');

  // If clicked inside the dedicated wishlist page, remove the card immediately
  const gridItem = btn.closest('[data-wishlist-item]');
  if (gridItem && document.querySelector('.wishlist-page-grid')) {
    gridItem.remove();
    if (getWishlist().length === 0) {
      const emptyContainer = document.getElementById('wishlist-empty') || document.querySelector('.wishlist-empty-state');
      if (emptyContainer) emptyContainer.style.display = 'block';
      const grid = document.getElementById('wishlist-grid') || document.querySelector('.wishlist-page-grid');
      if (grid) grid.style.display = 'none';
    }
  }
}, true); // CRITICAL: 'true' (Capture) executes before the <a> link receives the event